<template>
    <div class="tradingview-widget-container"></div>
</template>

<script>
export default {
    name: 'componentInvesting',
    watch: {
        '$store.state.theme'() {
            this.loadWidget();
        }
    },
    mounted() {
        this.loadWidget();
    },
    methods: {
        loadWidget() {
            this.$el.innerHTML = '';

            const widgetDiv = document.createElement('div');
            widgetDiv.className = 'tradingview-widget-container__widget';
            this.$el.appendChild(widgetDiv);

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js';
            script.async = true;
            script.innerHTML = JSON.stringify({
                symbol: 'FX_IDC:USDBRL',
                width: '100%',
                height: '220',
                locale: 'br',
                dateRange: '1M',
                colorTheme: this.$store.state.theme === 'light' ? 'light' : 'dark',
                isTransparent: false,
                autosize: false
            });
            this.$el.appendChild(script);
        }
    }
}
</script>
